import React, { useState, useRef } from "react";
import { FaArrowDown, FaArrowUp, FaHome, FaClipboardCheck } from "react-icons/fa";
import { Tabs, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";


const FrontDeskDashboard = () => {
  const maximizeBtnRef = useRef(null);
  const currentDate = new Date();
  const dayName = currentDate.toLocaleString("default", { weekday: "long" }); // Current day name
  const formattedDate = currentDate.toLocaleString("default", { day: "2-digit", month: "long", year: "numeric" }); // Formatted date

const leftStats = [
  { label: "Occupied", value: "34/126", color: "#6f42c1" },
  { label: "Available", value: "72", color: "#28a745" },
  { label: "Unavailable", value: "20", color: "#dc3545" },
];



  const activityStats = [
    { label: "Arrivals", value: "313/674", color: "#007bff" },
    { label: "Departures", value: "251/677", color: "#17a2b8" },
    { label: "New Bookings", value: "58", color: "#28a745" },
    { label: "Stay Overs", value: "182", color: "#ffc107" },
    { label: "Guest Messages", value: "04", color: "#6f42c1" },
    { label: "Cancelled Bookings", value: "03", color: "#dc3545" },
    { label: "Guests (Adults/Children)", value: "878/873", color: "#fd7e14" },
  ];

  const occupancyStats = {
    booked: 15,
    available: 4,
    blocked: 1,
    occupancy: 75, // Percentage
  };

  const guestData = [
    {
      name: "Bessie Cooper",
      phone: "710539489528",
      accommodation: "Standard Single - STS(219)",
      stay: { nights: 1, adults: 2, children: 0 },
      checkIn: "2023-12-20",
      checkOut: "2023-12-21",
      status: "Ready",
    },
    {
      name: "Theresa Webb",
      phone: "710539489528",
      accommodation: "Standard Single - STS(219)",
      stay: { nights: 4, adults: 1, children: 2 },
      checkIn: "2023-12-17",
      checkOut: "2023-12-21",
      status: "Payment Pending",
    },
    {
      name: "Dianne Kilmarnock-Thomas",
      phone: "710539489528",
      accommodation: "Deluxe King - DLK(341)",
      stay: { nights: 3, adults: 3, children: 5 },
      checkIn: "2023-12-18",
      checkOut: "2023-12-21",
      status: "Ready",
    },
    {
      name: "Cameron Harrison",
      phone: "710539489528",
      accommodation: "Deluxe King - DLK(341)",
      stay: { nights: 3, adults: 3, children: 0 },
      checkIn: "2023-12-18",
      checkOut: "2023-12-21",
      status: "Check-Out",
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* Page Header */}
        <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-4">
              <h3 className="page-title">NetShine Hospitality</h3>
            </div>
            <div className="col-md-8 float-end ms-auto">
              <div className="d-flex title-head">
                <div className="view-icons">
                  <button className="grid-view btn btn-link">
                    <i className="las la-redo-alt" />
                  </button>
                  <button
                    className="list-view btn btn-link"
                    id="collapse-header"
                    ref={maximizeBtnRef}
                  >
                    <i className="las la-expand-arrows-alt" />
                  </button>
                </div>

                <Link
                              to="/hospitality/guest-reservation" // Specify the target route here
                            className="btn add-btn custom-btn"
                          
                          >
                            <i className="la la-plus-circle custom-icon" /> Add New Reservations
                          </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Full-Row Stats */}
        <div className="stats-row">
      {activityStats.map((stat, index) => (
        <div key={index} className="stats-box">
          <div
            className="stats-border"
            style={{ backgroundColor: stat.color }}
          ></div>
          <div className="stats-content">
            <h5>{stat.value}</h5>
            <p>{stat.label}</p>
            <span className="view-details">View Details</span>
          </div>
        </div>
      ))}
    </div>

        {/* Main Content */}
        <div className="row">
          {/* Left Panel */}
          <div className="col-md-4">
      {/* Card Container */}
           {/* Card Container */}
           <div className="card">
        <div className="card-header text-center">
          {/* Prominent Day Name */}
          <h2 style={{ fontSize: "36px", fontWeight: "bold", marginBottom: "10px" }}>{dayName}</h2>
          <p style={{ fontSize: "18px", color: "#555" }}>{formattedDate}</p>
        </div>
        <div className="card-body">
          {/* 3-Column Stats Layout */}
          <div className="row mb-3">
            {leftStats.map((stat, index) => (
              <div key={index} className="col-4">
                <div
                  className="left-stat-box text-center"
                  style={{
                    backgroundColor: stat.color,
                    color: "#fff",
                    borderRadius: "8px",
                    padding: "10px",
                    fontWeight: "bold",
                    marginBottom: "15px",
                  }}
                >
                  <h3 style={{ margin: 0, fontSize: "20px" }}>{stat.value}</h3>
                  <p style={{ margin: 0, fontSize: "14px" }}>{stat.label}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Occupancy Stats with Progress Ring */}
          <div className="occupancy-stats text-center">
            <div className="progress-ring">
              <svg width="100" height="100">
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  stroke="#e5e5e5"
                  strokeWidth="10"
                  fill="none"
                />
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  stroke="#4caf50"
                  strokeWidth="10"
                  fill="none"
                  strokeDasharray={`${(occupancyStats.occupancy / 100) * 283} 283`}
                  strokeDashoffset="0"
                  style={{ transition: "stroke-dasharray 0.5s ease" }}
                />
              </svg>
              <span style={{ position: "absolute", fontSize: "18px", fontWeight: "bold", top: "40px", left: "50%", transform: "translateX(-50%)" }}>
                {occupancyStats.occupancy}%
              </span>
            </div>
            <p style={{ marginTop: "15px", fontSize: "16px", fontWeight: "500" }}>Occupancy</p>
          </div>
        </div>
      </div>
    </div>


          {/* Right Panel (Tabs with Table) */}
          <div className="col-md-8">
            <div className="card">
              <Tabs defaultActiveKey="arrivals" className="mb-3">
                <Tab eventKey="arrivals" title="Arrivals">
  

                  <table className="table">
                    <thead>
                      <tr>
                        <th>Guest</th>
                        <th>Accommodation</th>
                        <th>Stay</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {guestData.map((guest, index) => (
                        <tr key={index}>
                          <td>{guest.name}</td>
                          <td>{guest.accommodation}</td>
                          <td>
                            {guest.checkIn} → {guest.checkOut}
                            <p>
                              {guest.stay.nights} Night(s), {guest.stay.adults} Adult(s),{" "}
                              {guest.stay.children} Child(ren)
                            </p>
                          </td>
                          <td>
                            <button className="btn btn-primary">{guest.status}</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Tab>
                <Tab eventKey="departures" title="Departures">
                  <div>No Results</div>
                </Tab>
                <Tab eventKey="in-house" title="In-House">
                  <div>No Results</div>
                </Tab>
                <Tab eventKey="new-bookings" title="New Bookings">
                  <div>No Results</div>
                </Tab>
                <Tab eventKey="cancellations" title="Cancellations">
                  <div>No Results</div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrontDeskDashboard;
